// extracted by mini-css-extract-plugin
module.exports = {"contentWrap":"_2TE7lfflMCG4wxIKZHn6xL","toggleLabel":"fyCXIrIlQqA6BwlYLkO1I","downArrow":"MayFhqwc4w4AsS7o5sd_D"};